import { useTranslation } from 'react-i18next';

import { CircleCheckmarkIcon, tokens } from '@treams/treams-ui';

import ThankYouModal from '../../../../kakapo-ui-kit/components/modals/ThankYouModal';

export default function FeedbackThankYou(props: { external?: boolean }) {
	const { t } = useTranslation();

	return (
		<ThankYouModal
			title={t('common.feedback.feedbackResponseSent')}
			icon={
				<CircleCheckmarkIcon
					size={56}
					solid
					color={tokens.success.icon}
					aria-hidden
				/>
			}
			{...(props.external
				? {
						to: 'https://treams.nl',
						buttonTitle: t('common.feedback.viewTreamsWebsite'),
					}
				: {
						to: '/',
						buttonTitle: t('feedback.respond.success.backButton'),
					})}
		/>
	);
}
